import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import { NextActionButton } from './NextActionButton'
import { NOTES_BOLD_STYLE } from './styles'

const useStyles = createUseStyles({
  container: {
    backgroundColor: 'rgba(54, 52, 50, 0.02)',
    marginBottom: 31,
    flexShrink: 0,
  },
  text: {
    ...NOTES_BOLD_STYLE,
    color: '#90734F',
    marginLeft: 28,
  },
  textDisabled: {
    color: 'rgba(144, 115, 79, 0.24)',
  },
})

interface Props {
  onClick: () => void
  label: string
  disabled?: boolean
  className?: string
}

export const CreateNewButton: FC<Props> = flowMax(
  addDisplayName('CreateNewButton'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ label, onClick, disabled, classes, className }) => (
    <NextActionButton
      icon="create-manually"
      onClick={onClick}
      text={label}
      disabled={disabled}
      className={cx(classes.container, className)}
      textClassName={cx(classes.text, disabled && classes.textDisabled)}
    />
  )
)
